<!--
/*******************************************************************************
*@ 컴포넌트명   : StepProgress.vue
*@ 컴포넌트설명 : StepProgress 공통컴포넌트 (step있는 메뉴 상단에 단계표시)
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="step-progress">
    <div class="step-progress-bar" v-for="item in data" :key="item.id">
      <span
        :id="item.id"
        :class="{ active: item.active, check: item.check }"
        class="step-progress-bar--item"
      ></span>
    </div>
  </div>
</template>
<style type="scss" scoped></style>
<script>
export default {
  props: {
    step: {
      type: Number,
      required: true,
    },
    totalStep: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      data: [],
      currentStep: 0,
    };
  },
  created() {
    this.data = [];
    let current = this.step < 0 ? 1 : this.step;
    let total = this.totalStep < 1 ? 1 : this.totalStep < this.step ? this.step : this.totalStep;

    for (let i = 1; i <= total; i++) {
      this.data.push({ id: i, check: current > i ? true : false, active: current == i ? true : false });
    }
  },
};
</script>
